import { CircuitDayFormData } from '@/types/circuits/CircuitDaysFormData';
import { getCircuitSteps } from './getCircuitSteps';
import { getFileKeyFromUrl } from '../s3/getFileKeyFromUrl';

export const parseCircuitDaysToSubmit = (circuitDays: CircuitDayFormData[]) => {
  // Multi-day benefits intentionally reuse the same tempId across days.
  // Keep one payload entry per tempId for the whole circuit.
  const uniqueIDs = new Set<string>();
  return circuitDays.map((circuitDay, indexCircuitDay) => ({
    day: indexCircuitDay + 1,
    stepTitle: circuitDay.stepTitle,
    description: circuitDay.description,
    steps: getCircuitSteps(circuitDay.steps)
      .filter((step) => {
        if (uniqueIDs.has(step.tempId)) return false;
        uniqueIDs.add(step.tempId);
        return true;
      })
      .map((step) => ({ ...step, tempId: undefined })),
    imagesCount:
      circuitDay.images?.filter((image) => image instanceof Blob).length ?? 0,
    imagesUrls:
      circuitDay.images
        ?.filter((image) => !(image instanceof Blob))
        .map((image) => getFileKeyFromUrl(image as string)) ?? [],
    images: undefined,
  }));
};
